
import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const Unit = () => {
  return (
    <SettingsMetaData propertyName={"Unit_item"} viewPropertyName={"Unit"} />
  );
};
export default Unit;
